import * as React from 'react';
import { useEffect } from 'react';
import { isFunction } from '@src/utils/type-utils';

export default function Footer({ onBackTop, isShowBackTop = true }) {
  useEffect(() => {
    window.init_OMNI__COMMON__FOOTER();
    window.OMNI__COMMON__FOOTER = {
      to_top_handler: () => {
        isFunction(onBackTop) && onBackTop();
      }
    };
  }, []);

  useEffect(
    () => {
      const backTopButton = document.querySelector('#common_to_top_btn');
      if (!backTopButton) {
        return;
      }
      if (isShowBackTop) {
        backTopButton.style.display = 'block';
      } else {
        backTopButton.style.display = 'none';
      }
    },
    [isShowBackTop]
  );

  return <div id="OMNI__COMMON__FOOTER" className="OMNI__COMMON__FOOTER" />;
}
